"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CONFIG_FILE = exports.PERMITTED_SEXTANT_CONFIG_FILENAMES = void 0;
exports.PERMITTED_SEXTANT_CONFIG_FILENAMES = ['sextant.config.js'];
exports.DEFAULT_CONFIG_FILE = "module.exports = { plugins: [] };";
